import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { EMPTY_FIELD_ERROR, MOBILE_NO_ERROR } from "../../../../../common/constants";
import { mobileNumberValidation, openTextFieldMaxLength, typeNumberValid, VALIDATION } from "../../../../../common/commonValidations";
import { v4 as uuidv4 } from 'uuid';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from "../../../../../common/localStorageUtils";
import BackButton from '../../../../../common/backButton';
import { Button, Container, Card, CardContent, Switch, FormGroup, Fab, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel } from '@mui/material';
import { useTranslation } from "react-i18next";
import { useGrowerIndividulalContextData } from "../../registrationDetails";
import { CheckCircle as TickIcon, KeyboardArrowLeftRounded, Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import { toast } from 'react-toastify';
import { insertComment } from '../../commonRegistrationStakeholderAPIs';
import Badge from 'react-bootstrap/Badge';
import { handleNumberFieldFocus } from "../../../../../common/commonFunction";
import { SaveIcon } from "../../../../../common/icons";
import CommentIcon from '@mui/icons-material/Comment';

const JfmcDetails = (props) => {
    const { viewOnly, growerDetails, jfmcDetailsSectionOk, setJfmcDetailsSectionOk, shouldActOnSection, showWorkFlowButtons, enableSaveSubmitButtons, showCommentSection, setCommentsData, comments, setComments, enableFieldFunction, expandedSection, setExpandedSection, jfmcUpdatedDetails, setJfmcUpdatedDetails, errorMessage, setErrorMessage, regScruResourceUpdate, setRegScruResourceUpdate } = useGrowerIndividulalContextData();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [characterLimit] = useState(300);
    let jfmcComments = comments?.filter((item) => item.sectionName === "jfmc_details");
    const [jfmcComment, setJfmcComment] = useState("");
    const uuid = localStorage.getItem('uuid');
    // let regStakeholderMaster = growerDetails?.growers[0];
    let checkUserDetails = localStorage.getItem('role');
    useEffect(() => {
        if (growerDetails) {
            const regStakeholderMaster =
                growerDetails?.growers[0];
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails,
                divisionalForestOfficeName: regStakeholderMaster.divisionalForestOfficeName,
                divisionalForestOfficeAddress: regStakeholderMaster.divisionalForestOfficeAddress,
                divisionalForestOfficeContactName: regStakeholderMaster.divisionalForestOfficeContactName,
                divisionalForestOfficeContactNo: regStakeholderMaster.divisionalForestOfficeContactNo,
                forestRangeOfficeName: regStakeholderMaster.forestRangeOfficeName,
                forestRangeOfficeAddress: regStakeholderMaster.forestRangeOfficeAddress,
                forestRangeOfficeContactName: regStakeholderMaster.forestRangeOfficeContactName,
                forestRangeOfficeContactNo: regStakeholderMaster.forestRangeOfficeContactNo,
                forestRangeBeatName: regStakeholderMaster.forestRangeBeatName,
                forestRangeBeatAddress: regStakeholderMaster.forestRangeBeatAddress,
                forestRangeBeatContactName: regStakeholderMaster.forestRangeBeatContactName,
                forestRangeBeatContactNo: regStakeholderMaster.forestRangeBeatContactNo,

            });
        }
    }, [growerDetails]);


    const handleChange = (e) => {
        setJfmcUpdatedDetails({ ...jfmcUpdatedDetails, [e.target.name]: e.target.value });
        if (e.target.name === "divisionalForestOfficeName") {
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation
                    (e.target.value.slice(0, 50))
            });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, divisionalForestOfficeNameErr: '' })
            } else setErrorMessage({ ...errorMessage, divisionalForestOfficeNameErr: EMPTY_FIELD_ERROR })
        }
        if (e.target.name === "divisionalForestOfficeAddress") {
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation
                    (e.target.value.slice(0, 200))
            });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, divisionalForestOfficeAddressErr: '' })
            } else setErrorMessage({ ...errorMessage, divisionalForestOfficeAddressErr: EMPTY_FIELD_ERROR })
        }
        if (e.target.name === "divisionalForestOfficeContactName") {
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails, [e.target.name]: VALIDATION.fullNameValidation
                    (e.target.value.slice(0, 50))
            });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, divisionalForestOfficeContactNameErr: '' })
            } else setErrorMessage({ ...errorMessage, divisionalForestOfficeContactNameErr: EMPTY_FIELD_ERROR })
        }
        if (e.target.name === "divisionalForestOfficeContactNo") {
            setJfmcUpdatedDetails({ ...jfmcUpdatedDetails, [e.target.name]: mobileNumberValidation(e.target.value) });
            if (e.target.value.length === 10) {
                setJfmcUpdatedDetails({ ...jfmcUpdatedDetails, [e.target.name]: mobileNumberValidation(e.target.value) });
                setErrorMessage({ ...errorMessage, divisionalForestOfficeContactNoErr: '' })
            } else setErrorMessage({ ...errorMessage, divisionalForestOfficeContactNoErr: MOBILE_NO_ERROR })
        }
        if (e.target.name === "forestRangeOfficeName") {
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation
                    (e.target.value.slice(0, 50))
            });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, forestRangeOfficeNameErr: '' })
            } else setErrorMessage({ ...errorMessage, forestRangeOfficeNameErr: EMPTY_FIELD_ERROR })
        }
        if (e.target.name === "forestRangeOfficeAddress") {
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation
                    (e.target.value.slice(0, 200))
            });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, forestRangeOfficeAddressErr: '' })
            } else setErrorMessage({ ...errorMessage, forestRangeOfficeAddressErr: EMPTY_FIELD_ERROR })
        }
        if (e.target.name === "forestRangeOfficeContactName") {
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails, [e.target.name]: VALIDATION.fullNameValidation
                    (e.target.value.slice(0, 50))
            });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, forestRangeOfficeContactNameErr: '' })
            } else setErrorMessage({ ...errorMessage, forestRangeOfficeContactNameErr: EMPTY_FIELD_ERROR })
        }
        if (e.target.name === "forestRangeOfficeContactNo") {
            setJfmcUpdatedDetails({ ...jfmcUpdatedDetails, [e.target.name]: mobileNumberValidation(e.target.value) });
            if (e.target.value.toString().length === 10) {
                setJfmcUpdatedDetails({ ...jfmcUpdatedDetails, [e.target.name]: (e.target.value) });
                setErrorMessage({ ...errorMessage, forestRangeOfficeContactNoErr: '' })
            } else if(e.target.value.toString().length < 10) {
                setErrorMessage({ ...errorMessage, forestRangeOfficeContactNoErr: MOBILE_NO_ERROR })
            } 
            else setErrorMessage({ ...errorMessage, forestRangeOfficeContactNoErr: '' })
        }
        if (e.target.name === "forestRangeBeatName") {
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation
                    (e.target.value.slice(0, 50))
            });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, forestRangeBeatNameErr: '' })
            } else setErrorMessage({ ...errorMessage, forestRangeBeatNameErr: EMPTY_FIELD_ERROR })
        }
        if (e.target.name === "forestRangeBeatAddress") {
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation
                    (e.target.value.slice(0, 200))
            });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, forestRangeBeatAddressErr: '' })
            } else setErrorMessage({ ...errorMessage, forestRangeBeatAddressErr: EMPTY_FIELD_ERROR })
        }
        if (e.target.name === "forestRangeBeatContactName") {
            setJfmcUpdatedDetails({
                ...jfmcUpdatedDetails, [e.target.name]: VALIDATION.fullNameValidation
                    (e.target.value.slice(0, 200))
            });
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, forestRangeBeatContactNameErr: '' })
            } else setErrorMessage({ ...errorMessage, forestRangeBeatContactNameErr: EMPTY_FIELD_ERROR })
        }
        if (e.target.name === "forestRangeBeatContactNo") {
            setJfmcUpdatedDetails({ ...jfmcUpdatedDetails, [e.target.name]: mobileNumberValidation(e.target.value) });
            if (e.target.value.length === 10) {
                setJfmcUpdatedDetails({ ...jfmcUpdatedDetails, [e.target.name]: mobileNumberValidation(e.target.value) });
                setErrorMessage({ ...errorMessage, forestRangeBeatContactNoErr: '' })
            } else  if (e.target.value.length < 10) { setErrorMessage({ ...errorMessage, forestRangeBeatContactNoErr: MOBILE_NO_ERROR })}
            else setErrorMessage({ ...errorMessage, forestRangeBeatContactNoErr: '' })
        }



    }
    const checkValidations = (e) => {
        if (showCommentSection &&
            (shouldActOnSection.jfmc_details && !comments.find((item) => item.sectionName === "jfmc_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null))) {
            toast.error("Please enter comments for required sections");
            return
        }
        
    }

    const commentsColumn = [
        {
            field: 'comment', headerName: t('reg.comments'), width: 330,
            renderCell: (params) => {
                return (
                    <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
                        {params.value.split('<br />').map((line, index) => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </div>
                )
            }
        },
        {
            field: 'createdByName', headerName: t('preReg.name'), width: 200
        },
        {
            field: 'userRole', headerName: t('reg.userRole'), width: 200
        },
        {
            field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
        },
    ]

    const onSaveComment = (comment, sectionName, sectionOk) => {
        const commentObject = {
            comment: comment,
            stakeholderMasterId: growerDetails?.growers[0]?.regStakeholderMasterId,
            sectionName: sectionName,
            sectionId: growerDetails?.growers[0]?.id,
            sectionOk: sectionOk,
            userRole: localStorage.getItem('role'),
            createdBy: decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid,
        }
        comment ? insertComment([commentObject], growerDetails?.growers[0]?.regStakeholderMasterId, setCommentsData) : toast.error("Please enter comment")
        setJfmcComment("");
        setErrorMessage({ ...errorMessage, jfmcForestCommentError: "" });
   }

    return (
        <>{jfmcUpdatedDetails && <>
            <Grid item xs={12}>
                <Accordion mt={1}
                    expanded={expandedSection === "jfmcForest"}
                    onChange={(event, expanded) => {
                        setExpandedSection(expanded ? "jfmcForest" : "");
                    }}
                >
                    <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (jfmcDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                        expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                    >
                        <Stack ml={2} direction="row">
                            {showCommentSection && !regScruResourceUpdate && (jfmcDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                            <Typography variant="subtitle1"> Forest Details</Typography>
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (jfmcDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                            <Grid item xs={12} style={{ marginBottom: "1em" }} alignItems="center">
                                <Stack direction="row" alignItems="center">
                                    {showCommentSection && !regScruResourceUpdate && (jfmcDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                    <Typography variant="h6">
                                        {t('reg.divisionalForestOffice')}
                                    </Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.divisionalForestOfficeNameErr}
                                            helperText={errorMessage.divisionalForestOfficeNameErr}
                                            name="divisionalForestOfficeName"
                                            type="text"
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            label={t('preReg.name')}
                                          
                                            value={jfmcUpdatedDetails.divisionalForestOfficeName}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.divisionalForestOfficeContactNameErr}
                                            helperText={errorMessage.divisionalForestOfficeContactNameErr}
                                            name="divisionalForestOfficeContactName" type="text"
                                            label={t('reg.contactPersonName')}
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                           
                                            value={jfmcUpdatedDetails.divisionalForestOfficeContactName}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.divisionalForestOfficeAddressErr}
                                            helperText={errorMessage.divisionalForestOfficeAddressErr}
                                            name="divisionalForestOfficeAddress"
                                            type="text"
                                            label={t('main.address')}
                                            multiline
                                           
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            value={jfmcUpdatedDetails.divisionalForestOfficeAddress}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.divisionalForestOfficeContactNoErr}
                                            helperText={errorMessage.divisionalForestOfficeContactNoErr}
                                            name="divisionalForestOfficeContactNo"
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                            label={t('reg.contactPersonNumber')}
                                            
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            value={jfmcUpdatedDetails.divisionalForestOfficeContactNo}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    {t('reg.forestRangeOffice')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.forestRangeOfficeNameErr}
                                            helperText={errorMessage.forestRangeOfficeNameErr}
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            value={jfmcUpdatedDetails.forestRangeOfficeName}
                                            onChange={(e) => handleChange(e)}
                                            name="forestRangeOfficeName"
                                            type="text"
                                            label={t('preReg.name')}
                                           
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.forestRangeOfficeContactNameErr}
                                            helperText={errorMessage.forestRangeOfficeContactNameErr}
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            value={jfmcUpdatedDetails.forestRangeOfficeContactName}
                                            onChange={(e) => handleChange(e)}
                                            name="forestRangeOfficeContactName"
                                            type="text"
                                            label={t('reg.contactPersonName')}
                                            />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.forestRangeOfficeAddressErr}
                                            helperText={errorMessage.forestRangeOfficeAddressErr}
                                            value={jfmcUpdatedDetails.forestRangeOfficeAddress}
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            multiline
                                            onChange={(e) => handleChange(e)}
                                            name="forestRangeOfficeAddress"
                                            type="text"
                                            label={t('main.address')}
                                            />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.forestRangeOfficeContactNoErr}
                                            helperText={errorMessage.forestRangeOfficeContactNoErr}
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            name="forestRangeOfficeContactNo"
                                            onChange={(e) => handleChange(e)}
                                            value={jfmcUpdatedDetails.forestRangeOfficeContactNo}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('reg.contactPersonNumber')}
                                            onKeyDown={(evt) => typeNumberValid(evt)} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    {t('reg.forestBeatOffice')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.forestRangeBeatNameErr}
                                            helperText={errorMessage.forestRangeBeatNameErr}
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            onChange={(e) => handleChange(e)}
                                            value={jfmcUpdatedDetails.forestRangeBeatName}
                                            name="forestRangeBeatName"
                                            type="text"
                                            label={t('preReg.name')}
                                            InputProps={{
                                                style: { textTransform: "capitalize" }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.forestRangeBeatContactNameErr}
                                            helperText={errorMessage.forestRangeBeatContactNameErr}
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            onChange={(e) => handleChange(e)}
                                            value={jfmcUpdatedDetails.forestRangeBeatContactName}
                                            name="forestRangeBeatContactName"
                                            type="text"
                                            label={t('reg.contactPersonName')}
                                           
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.forestRangeBeatAddressErr}
                                            helperText={errorMessage.forestRangeBeatAddressErr}
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            onChange={(e) => handleChange(e)}
                                            value={jfmcUpdatedDetails.forestRangeBeatAddress}
                                            name="forestRangeBeatAddress"
                                            type="text"
                                            label={t('main.address')}
                                            multiline
                                           
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.forestRangeBeatContactNoErr}
                                            helperText={errorMessage.forestRangeBeatContactNoErr}
                                            disabled={!enableFieldFunction(shouldActOnSection.jfmc_details, false)}
                                            onChange={(e) => handleChange(e)}
                                            value={jfmcUpdatedDetails.forestRangeBeatContactNo}
                                            name="forestRangeBeatContactNo"
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('reg.contactPersonNumber')}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {showCommentSection && <>
                            <Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                            <Grid item xs={8}>
                                  <TextField sx={{ width: "100%" }}
                                    label={t('reg.comment')}
                                    name="comment"
                                    inputProps={{
                                        maxLength: 300,
                                    }}
                                    multiline
                                    disabled={!shouldActOnSection.jfmc_details || viewOnly}
                                    value={jfmcComment}
                                    onChange={(e) => setJfmcComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                />
                                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                    <Badge bg={`${jfmcComment?.length > characterLimit ? 'danger' : 'primary'}`}>{jfmcComment?.length}/{characterLimit}</Badge>
                  </div>
                </Grid>
                <Grid item xs={2}>
                                <FormGroup>
                                    <FormControlLabel control={<Switch disabled={!shouldActOnSection.jfmc_details || viewOnly} checked={jfmcDetailsSectionOk}
                                        onChange={(e) => setJfmcDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2" gutterBottom>
                                            {t('reg.detailsOk')}?
                                        </Typography>} />
                                </FormGroup>
                                </Grid>
                <Grid xs={2}>
                                <Button variant="contained" disabled={!shouldActOnSection.jfmc_details || viewOnly}
                                    onClick={() => onSaveComment(jfmcComment, "jfmc_details", jfmcDetailsSectionOk)}
                                    startIcon={<CommentIcon/>}
                                >
                                    {t('preReg.addComment')}
                                </Button>
                                </Grid>
                                </Grid>
                            <div>
                                <Accordion mt={1}>
                                    <AccordionSummary expandIcon={<AccordionIcon />}>
                                        <Typography variant="subtitle1" >{t('reg.commentHistory')}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box style={{ height: 300, width: '100%' }}>
                                            <DataGrid
                                                rows={jfmcComments ? jfmcComments : []}
                                                columns={commentsColumn}
                                                pageSize={10}
                                                getRowHeight={() => 'auto'} />
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </div></>}
                    </AccordionDetails>
                </Accordion>
            </Grid>
        </>}
        {/* <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                {!showWorkFlowButtons && <Button sx={{ minWidth: 100, ml: 1 }}
                    variant="contained"
                    onClick={(e) => props.updateJfmcCallback(details, "forestJfmc", "save")} disabled={!enableSaveSubmitButtons || state?.viewOnly}
                >{t('preReg.save')}</Button>}
                <Button sx={{ minWidth: 100, ml: 1 }}
                    variant="contained"
                    value="Next" onClick={(e) => checkValidations(e)}
                >{t('preReg.next')}</Button>
            </Box> */}
        </>
    );
}
export default JfmcDetails;